<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="editorial-header" :class="{'theme-dark': isDarkTheme}">
      <Heading
        class="title"
        default-tag="h1"
        :class="alignmentClass"
        :tag-field="headingSizeField"
        :text-field="titleField"
        :desktop-size="sizeDesktop"
        :mobile-size="sizeMobile"
      />
      <editorial-cta
        :fields="fields"
        :desktop-alignment="desktopPosition"
      />
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import mapFields from '~/helpers/map-fields'
import get from '~/helpers/get'
import { decreaseTagValue } from '~/helpers/decrease-tag-value'
import ThemeMixin from '~/mixins/theme'
import ScRender from '../sc-render'
import EditorialCta from '../editorial-cta'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'EditorialHeader',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [ThemeMixin],

  components: {
    ScRender,
    ScText: Text,
    EditorialCta,
    Heading
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapFields({
      titleField: 'title',
      headingSizeField: 'headingSize',
      headingSizeValue: 'headingSize.value'
    }),

    sizeDesktop () {
      if (this.headingSizeValue) {
        return `size-${this.headingSizeValue[1]}`
      }

      return 'size-2'
    },
    sizeMobile () {
      return `size-${decreaseTagValue(this.headingSizeField).value[1]}`
    },
    desktopPosition () {
      return get(this.fields, 'desktopPosition.value', 'Center')
    },
    alignmentClass () {
      return `desktop-align-${this.desktopPosition}`.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.editorial-header {
  padding: 0 $space-050;
  margin-bottom: $space-090;

  &:first-child {
    margin-top: $space-090;
  }

  @include tablet() {
    padding: 0 $space-060;
    margin-bottom: $space-100;
  }

  .title {
    text-align: left;

    &.desktop-align-center {
      @include tablet {
        text-align: center;
      }
    }
  }

  &.theme-dark {
    .title {
      color: $color-white;
    }
  }
}
</style>
